const DispositionReducer = (state = {}, action) => {
    switch (action.type) {
      case "DIS_LISTVIEW":
        return Object.assign({}, state, {
          DIS_ListView: action.data
        });
      case "DIS_ACTIVITY":
        return Object.assign({}, state, {
          DIS_Actvity: action.data
        });
      case "DIS_ADD":
        return Object.assign({}, state, {
          DIS_Add: action.data
        });
      case "DISEDIT_DOCS":
        return Object.assign({}, state, {
          geteditdis: action.data
        });
        case "SHARE_DISFILES":
          return Object.assign({}, state, {
            shareddisfiles: action.data
          });
      case "SHARE_DISDATAS":
        return Object.assign({}, state, {
          shareddisdata: action.data
        });
      case "ERROR_DISDATAS":
        return Object.assign({}, state, {
          errordispass: action.data
        });
      default:
        return state;
    }
  };
  
  export default DispositionReducer;
  
  